<template>
  <v-flex xs12>
    <v-card class="pa-4">
      <v-textarea 
        :label="$lang.labels.url"
        readonly
        auto-grow
        rows="1"
        v-model="log.url"
      />
      <v-textarea 
        :label="$lang.labels.errorMessage"
        readonly
        v-model="log.errorMessage"
        auto-grow
        rows="1"
      />
      <v-textarea 
        :label="$lang.labels.data"
        readonly
        v-model="log.data"
        auto-grow
        rows="1"
      />
      <p class="mt-3">{{ $lang.labels.statusCode }}: {{ log.statusCode }} </p>
      <p class="mt-3">{{ $lang.labels.created }}: {{ createdOn }} </p>
      <v-layout>
        <v-btn flat class="mx-0" @click="$emit('close')">
          <v-icon>keyboard_arrow_left</v-icon>
          {{$lang.actions.close}}
        </v-btn>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['log'],
    data: () => ({
      log: '',
      createdOn: '',
    }),
    created() {
      this.$http.get(`system/logs/${this.log.id}`)
        .then((res) => {
          if(res.body.status === 'Success') {
            this.log = res.body.log;
            this.createdOn = this.formatDate(this.log.createdOn);
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = res.body.statusText || err.body.message;
        });
    },
    methods: {
      formatDate(date) {
         return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
    }
  };
</script>

<style lang="scss" scoped>
  .label {
    min-width: 140px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-end;
  }
  p {
    font-size: 17px;
  }
</style>


// WEBPACK FOOTER //
// viewLog.vue?1f228c8b